/**
 * Post message service
 */
import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { get, isEmpty, set } from 'lodash';

import { event_selection_from_portal, EVENT_SELECTION_SUCCESS } from '@rpt-ngrx/actions/events.action';
import {
    configurable_site_selection_from_portal,
    GET_RECENT_SITES_LIST_SUCCESS,
    get_recent_sites_success,
    site_selection_from_portal,
    SITE_SELECTION_SUCCESS,
} from '@rpt-ngrx/actions/sites.action';
import { PreferencesService } from '@services/preferences/preferences.service';
import { IIframeMessageType } from '@shared/types';

@Injectable()
export class PostMessageService {
    public platform: string = 'XDM';
    public portalPlatform: string = 'XPRT';
    private isMultiple = false;
    private compKey: string;

    constructor(
        private store: Store,
        private preferences: PreferencesService,
    ) {}

    public sendMessage(msgType: string, messageId: string, payload: object): void {
        const message: IIframeMessageType = {
            messageId,
            payload: {
                options: payload,
                ...payload,
            },
            msg_type: msgType,
            platform: this.platform,
            timestamp: new Date().toISOString(),
        };
        this.isMultiple = get(payload, 'multiselect');
        this.compKey = get(payload, 'compKey');

        // Fix wrong option name and property reading in portal site selector
        if (get(payload, 'multiselect') === true) {
            set(message, 'payload.multiply', true);
            set(message, 'payload.options.multiply', true);
        }
        parent.postMessage(JSON.stringify(message), '*');
    }

    public processPostMessage(msg: IIframeMessageType): void {
        if (msg.platform === this.portalPlatform) {
            const isConfigurableSiteSelection = !isEmpty(this.compKey);
            switch (msg.msg_type) {
                case GET_RECENT_SITES_LIST_SUCCESS:
                    this.store.dispatch(get_recent_sites_success({ msg }));
                    break;

                case SITE_SELECTION_SUCCESS: {
                    if (get(msg, 'payload.modalResult') === 'cancel') {
                        return;
                    }
                    const portalSitePayload = {
                        ...msg,
                        isMultiple: this.isMultiple,
                    };
                    this.preferences.setSiteHierarchyId(msg.payload?.hierarchyId);
                    this.store.dispatch(
                        isConfigurableSiteSelection
                            ? configurable_site_selection_from_portal({
                                  payload: { ...portalSitePayload, compKey: this.compKey },
                              })
                            : site_selection_from_portal({ payload: portalSitePayload }),
                    );
                    break;
                }

                case EVENT_SELECTION_SUCCESS:
                    if (get(msg, 'payload.modalResult') === 'cancel') {
                        return;
                    }
                    this.store.dispatch(
                        event_selection_from_portal({ payload: { ...msg, isMultiple: this.isMultiple } }),
                    );
                    break;

                default:
                    break;
            }
        }
    }
}
